import numbro from 'numbro';
import { compose, head } from 'ramda';

import { template } from '../../../lib/template';
import Link from '../../Link';
import { Markdown } from '../../Markdown';

import styles from './styles.module.scss';

const DEFAULT_TAKE_RATE = '10-25%';

export default function LegalStatement({ games, legalStatement, theme }) {
  return (
    <Markdown
      escapeHtml={false}
      className={styles.legal}
      components={{
        a: (props) => <Link {...props} target="_blank" theme={theme} />,
      }}
    >
      {template(legalStatement, {
        takeRate: compose((item) => {
          const takeRate = item?.game?.estimatedTakeRate;
          return takeRate === 0 || takeRate > 0
            ? numbro(takeRate).format({
                output: 'percent',
                mantissa: 0,
              })
            : DEFAULT_TAKE_RATE;
        }, head)(games),
      })}
    </Markdown>
  );
}
